import {
  OverlayArrow,
  Tooltip as AriaTooltip,
  type TooltipProps as AriaTooltipProps,
  Button,
  TooltipTrigger,
  TooltipTriggerComponentProps,
} from "react-aria-components";

import styles from "./Tooltip.module.css";
import { ReactNode, useState } from "react";
import { AriaButton } from "../Buttons/AriaButton/AriaButton";

export interface TooltipProps extends Omit<AriaTooltipProps, "children"> {
  children?: React.ReactNode;
}
export interface TriggerProps extends Omit<TooltipTriggerComponentProps, "children"> {
  children?: React.ReactNode;
}

export function Tooltip({
  insideToolTip,
  triggerElement,
  tooltipProps,
  triggerProps,
  delay,
}: {
  insideToolTip: ReactNode;
  triggerElement: ReactNode;
  tooltipProps?: TooltipProps;
  triggerProps?: TriggerProps;
  delay?: number;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <TooltipTrigger {...triggerProps} delay={delay ?? 0} isOpen={isOpen} onOpenChange={setIsOpen}>
      <AriaButton
        variant="quiet"
        slot={undefined}
        style={{ outline: "none", display: "flex", alignItems: "center", justifyContent: "center" }}
        onPress={() => setIsOpen(!isOpen)}
      >
        {triggerElement}
      </AriaButton>
      <TooltipOnly {...tooltipProps}>{insideToolTip}</TooltipOnly>
    </TooltipTrigger>
  );
}

export function TooltipOnly({ children, ...props }: TooltipProps) {
  return (
    <AriaTooltip {...props} className={styles.reactAriaTooltip}>
      <OverlayArrow className={styles.reactAriaOverlayArrow}>
        <svg width={8} height={8} viewBox="0 0 8 8">
          <title>Arrow</title>
          <path d="M0 0 L4 4 L8 0" />
        </svg>
      </OverlayArrow>
      <div style={{ maxHeight: "inherit", overflow: "hidden" }}>{children}</div>
    </AriaTooltip>
  );
}

export const HoverTooltip = ({ children, tooltip }: { children: React.ReactNode; tooltip: React.ReactNode }) => {
  return (
    <div className={styles.wrapper}>
      {children}
      <div className={styles.tooltip}>{tooltip}</div>
    </div>
  );
};
